import { NgModule } from '@angular/core';
import { AngularFireAuthGuard, redirectLoggedInTo } from '@angular/fire/compat/auth-guard';
import { RouterModule, Routes } from '@angular/router';
import { OrganisationInvitationValidationComponent } from '@suvo-bi-users';
import { LoginPageComponent } from './login/login-page.component';
import { NewShopComponent } from './new-shop';
import { PublicComponent } from './public.component';
import { RegisterPageComponent } from './register/register-page.component';
import { VerifyPageComponent } from './verify/verify-page.component';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'register', component: RegisterPageComponent },
      { path: 'register/:token/:email', component: RegisterPageComponent },
      {
        path: 'login',
        component: LoginPageComponent,
        data: {
          pageTitle: 'Log in',
          pageSubtitle: 'Continue to informally',
          supportLinkLabel: 'Need Help?',
          supportLink: '/help-center/login',
        },
      },
      {
        path: 'login/:token/:email',
        component: LoginPageComponent,
        data: {
          pageTitle: 'Log in',
          pageSubtitle: 'Continue to informally',
          supportLinkLabel: 'Need Help?',
          supportLink: '/help-center/login',
        },
      },
      {
        path: 'help-center',
        children: [
          {
            path: 'login',
            component: LoginPageComponent,
            data: {
              pageTitle: 'Log in to the Help Center',
              pageSubtitle: 'Access Informally help articles and support resources.',
              supportLinkLabel: 'Back to product login',
              supportLink: '/login',
            },
          },
        ],
      },
      { path: 'invites', component: OrganisationInvitationValidationComponent },
      { path: 'verify', component: VerifyPageComponent },
    ],
  },

  {
    path: 'new-shop',
    pathMatch: 'full',
    component: NewShopComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
